import React from 'react';
import Footer from '../components/Footer';

const PrivacyPolicy = () => {
    return (
        <>
        <div className="policy-page">
            <div className="policy-container">
                <h1>Privacy Policy</h1>
                <p className="last-updated">Last Updated: May 2026</p>

                <section>
                    <h2>1. Introduction</h2>
                    <p>
                        Bluewave Co. ("we," "us," "our," or "Company") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website.
                    </p>
                </section>

                <section>
                    <h2>2. Information We Collect</h2>
                    <p>We may collect information about you in a variety of ways. The information we may collect on the site includes:</p>
                    <ul>
                        <li><strong>Personal Data:</strong> Name, email address, phone number, company name, job title, and other information you voluntarily provide when filling out forms or contacting us.</li>
                        <li><strong>Automatic Data:</strong> IP address, browser type, operating system, pages visited, time spent on pages, and other usage statistics.</li>
                        <li><strong>Cookies:</strong> Information collected through cookies and similar tracking technologies.</li>
                    </ul>
                </section>

                <section>
                    <h2>3. How We Use Your Information</h2>
                    <p>We use the information we collect for various purposes, including:</p>
                    <ul>
                        <li>To provide and maintain our services</li>
                        <li>To respond to your inquiries and provide customer support</li>
                        <li>To send promotional communications (with your consent)</li>
                        <li>To improve our website and services</li>
                        <li>To comply with legal obligations</li>
                        <li>To prevent fraud and enhance security</li>
                    </ul>
                </section>

                <section>
                    <h2>4. Information Sharing</h2>
                    <p>
                        We do not sell, trade, or rent your personal information to third parties. We may share information with:
                    </p>
                    <ul>
                        <li>Service providers who assist us in operating our website and conducting our business</li>
                        <li>Legal authorities when required by law</li>
                        <li>Business partners with your consent</li>
                    </ul>
                </section>

                <section>
                    <h2>5. Data Security</h2>
                    <p>
                        We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure.
                    </p>
                </section>

                <section>
                    <h2>6. Your Rights</h2>
                    <p>You have the right to:</p>
                    <ul>
                        <li>Access the personal information we hold about you</li>
                        <li>Request correction of inaccurate data</li>
                        <li>Request deletion of your information</li>
                        <li>Opt-out of marketing communications</li>
                        <li>Data portability</li>
                    </ul>
                </section>

                <section>
                    <h2>7. Cookies and Tracking</h2>
                    <p>
                        Our website uses cookies to enhance your browsing experience. You can control cookie preferences through your browser settings. Some cookies are necessary for the website to function properly.
                    </p>
                </section>

                <section>
                    <h2>8. Third-Party Links</h2>
                    <p>
                        Our website may contain links to third-party websites. We are not responsible for the privacy practices of other websites. Please review their privacy policies before providing any information.
                    </p>
                </section>

                <section>
                    <h2>9. Contact Us</h2>
                    <p>
                        If you have questions about this Privacy Policy or our privacy practices, please contact us at:
                    </p>
                    <p>
                        <strong>Email:</strong> <a href="mailto:info@bluewavesshipmanagement.com">info@bluewavesshipmanagement.com</a><br />
                        <strong>Phone:</strong> <a href="tel:+94719645645">+94 719 745 745</a>
                    </p>
                </section>

                <section>
                    <h2>10. Changes to This Privacy Policy</h2>
                    <p>
                        We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.
                    </p>
                </section>
            </div>
           
        </div>
         <Footer />
         </>
    );
};

export default PrivacyPolicy;
